module.exports = __webpack_public_path__ + "static/media/icon-local.3f5f8032.png";